/* eslint-disable max-len */
/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import utils, { TClaim, TJoin, TNonEmptyArray, TRole, TRoleClaim, TTenant, TUser, TUserRole } from "../../helpers/utils.graphql";
import { CommandResult_RoleClaim, ListCommandResult_RoleClaim } from "../../helpers/types.graphql";
import { CommandResult, ListCommandResult } from "../fragment.graphql";

export type TGlobal = TRoleClaim
  | TJoin<"tenant", TTenant>
  | TJoin<"role", TRole>
  | TJoin<"claim", TClaim>

type TRoleClaimByIdFunctions = { getByID: CommandResult_RoleClaim }
export type TRoleClaimByIdQueries = { roleClaim: TRoleClaimByIdFunctions };
export const roleClaimById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query roleClaimById($id: Guid!) {
    roleClaim {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_RoleClaim")}
`;

type TRoleClaimAllWithPaginationFunctions = { getAllWithPagination: ListCommandResult_RoleClaim }
export type TRoleClaimAllWithPaginationQueries = { roleClaim: TRoleClaimAllWithPaginationFunctions };
export const roleClaimAllWithPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query roleClaimAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    roleClaim {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_RoleClaim")}
`;

type TRoleClaimAllWithSortedPaginationFunctions = { getAllWithSortedPagination: ListCommandResult_RoleClaim }
export type TRoleClaimAllWithSortedPaginationQueries = { roleClaim: TRoleClaimAllWithSortedPaginationFunctions };
export const roleClaimAllWithSortedPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query roleClaimAllWithSortedPagination(
    $page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]
  ) {
    roleClaim {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_RoleClaim")}
`;